import type { RefObject } from "react";
import { useCallback, useEffect, useRef } from "react";

export type Handler = (event?: MouseEvent | TouchEvent) => void;

export const useOnClickOutside = <T extends HTMLElement>(
  handler?: Handler
): RefObject<T> => {
  const ref = useRef<T>(null);

  const handleClick = useCallback(
    (e: MouseEvent | TouchEvent) => {
      if (ref.current && ref.current.contains(e.target as Node)) return;
      if (!handler) return;
      handler(e);
    },
    [handler, ref]
  );

  useEffect(() => {
    document.addEventListener("mousedown", handleClick);
    document.addEventListener("touchstart", handleClick);

    return () => {
      document.removeEventListener("mousedown", handleClick);
      document.removeEventListener("touchstart", handleClick);
    };
  }, [handleClick]);

  return ref;
};
